exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-foto-js": () => import("./../../../src/pages/foto.js" /* webpackChunkName: "component---src-pages-foto-js" */),
  "component---src-pages-foto-ufficiali-js": () => import("./../../../src/pages/foto_ufficiali.js" /* webpackChunkName: "component---src-pages-foto-ufficiali-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-selfiemirror-js": () => import("./../../../src/pages/selfiemirror.js" /* webpackChunkName: "component---src-pages-selfiemirror-js" */)
}

